// src/components/PublicationCard.jsx
import React from "react";
import "./Styles/PublicationCard.scss";

const PublicationCard = ({ publication, onSelect }) => {
  return (
    <article className="publication-card" onClick={onSelect}>
      <h2 className="publication-title">{publication.title}</h2>
      <p className="publication-author">by {publication.author}</p>
      <p className="publication-year">{publication.publication_date}</p>
      <p className="publication-summary">{publication.description}</p>
    </article>
  );
};

export default PublicationCard;
